import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

export type BadgeType =
  | 'Default'
  | 'Neutral'
  | 'Warning'
  | 'Success'
  | 'Information'
  | 'Danger'
  | 'None';
export type BadgeSize = 'Small' | 'Medium';
export type BadgeVariant = 'Solid' | 'Outline';

@Component({
  selector: 'lib-badge',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class BadgeComponent {
  @Input() type: BadgeType = 'Default';
  @Input() size: BadgeSize = 'Small';
  @Input() variant: BadgeVariant = 'Solid';
  @Input() label: string = 'Badge';

  protected get classes(): string[] {
    const classList = ['badge'];

    classList.push(`badge--${this.type.toLowerCase()}`);
    classList.push(`badge--${this.size.toLowerCase()}`);
    classList.push(`badge--${this.variant.toLowerCase()}`);

    return classList;
  }
}
